<div class="container">
    <div class="left-section" >
      <app-avatar class="image"
      [email]="user?.email"
      (imageBroken)="imageBroken($event)"
      [userInitials]="getInitials(user)"
    >
    </app-avatar>
      </div>
    <div class="right-section">
      <div class="user-info">
        <p style="font-size: 14px;font-weight: 700;">{{user?.firstName}} {{user?.lastName}}</p>
        <p style="font-size: 12px;" appEllipsisTooltip="">{{user?.email}}</p>
        <p style="font-size: 12px;">{{user?.title}}</p>
      </div>
      <div class="delete-container">
        <i class="icon-delete-default-16" (click)="delete()"></i>
      </div>
    </div>
</div>